import React, { useContext, useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { firebaseAuth } from '../../providers/AuthProvider';
import firebase from 'firebase/compat/app';
import ReportTable from './ReportTable';
import { formatCustomerCareDate } from './customerCareDashboard';

const config = (row, key) => row.config?.[key] ?? row[key];
const columns = [
  { key: 'program', label: 'Program', value: (row) => config(row, 'program') || '' },
  { key: 'eventName', label: 'Request', value: (row) => config(row, 'eventName') || '',
    render: (row) => <Link className="underline" to={`/manage/campaign-code-requests/${row.id}`}
      onClick={(event) => event.stopPropagation()}>{config(row, 'eventName') || 'Open request'}</Link> },
  { key: 'eventDate', label: 'Event dates', value: (row) => row.externalUse ? 'External use' :
    `${config(row, 'eventDate') || ''}${config(row, 'eventEndDate') ? ` - ${config(row, 'eventEndDate')}` : ''}` },
  { key: 'leadCampaignCode', label: 'Lead code', value: (row) => row.leadCampaignCode || '' },
  { key: 'ihCampaignCode', label: 'IH code', value: (row) => row.ihCampaignCode || '' },
  { key: 'requesterEmail', label: 'Requester', value: (row) => row.requesterEmail || row.requestor?.[0]?.name || '' },
  { key: 'createdAt', label: 'Request date', value: (row) => formatCustomerCareDate(row.createdAt), sortValue: (row) => row.createdAt?.seconds || 0 },
  { key: 'status', label: 'Approval', value: (row) => row.status || (row.approved ? 'approved' : 'draft') },
];
const filters = [
  { key: 'approval', label: 'Approval stage', multiple: true, options: [['submitted', 'Submitted'], ['draft', 'Draft'], ['crm_pending', 'CRM pending'], ['approved', 'Approved']], value: (row) => row.status || (row.approved ? 'approved' : 'draft') },
  { key: 'driving', label: 'Event type', options: [['true', 'Driving'], ['false', 'Non-driving'], ['unknown', 'Not specified']],
    value: (row) => config(row, 'drivingEvent') === null || config(row, 'drivingEvent') === undefined
      ? 'unknown' : String(!!config(row, 'drivingEvent')) },
  { key: 'leadTrigger', label: 'Lead trigger', options: [['optIn', 'Registration opt-in'], ['checkedIn', 'Checked-in'], ['none', 'Interaction History only']], value: (row) => config(row, 'leadTrigger') || '' },
  { key: 'schedule', label: 'Schedule', options: [['during', 'During Event'], ['end', 'End of Event'], ['ongoing', 'Ongoing']], value: (row) => config(row, 'schedule') || '' },
];

export default function CampaignCodes() {
  const { user } = useContext(firebaseAuth);
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    firebase.functions().httpsCallable('appV2/listCampaignRequests')({})
      .then((result) => setRows(result.data || []))
      .catch(() => setRows([])).finally(() => setLoading(false));
  }, []);
  if (Number(user?.role) !== 1 && user?.crmManager !== true) {
    return <Navigate to="/manage/permissions" replace />;
  }
  return <ReportTable title="Campaign Codes" rows={rows} loading={loading} columns={columns}
    filters={filters} dateKey="createdAt" storageKey="campaignCodesTable:v1"
    exportName="campaign-codes" canExport={Number(user?.role) === 1 || user?.crmManager === true}
    action={(Number(user?.role) === 1 || user?.crmManager === true) &&
      <button type="button" className="rounded-md bg-zinc-900 px-3 py-2 text-sm text-white dark:bg-white dark:text-zinc-900"
      onClick={() => navigate('/manage/campaign-code-requests')}>Add Campaign Request</button>}
    onRowClick={(row) => navigate(`/manage/campaign-code-requests/${row.id}`)} />;
}
